export const mainNavLinks = [
  { label: 'About Us', path: '/about-us' },
  { label: 'PLC 4.0', path: '/plc-4' },
  { label: 'Event', path: '/events' },
  { label: 'Stories', path: '/stories' },
]

export const quickLinks = [
  { label: 'About Us', path: '/about-us' },
  { label: 'PLC 4.0', path: '/plc-4' },
  { label: 'Our Events', path: '/events' },
  { label: 'Stories', path: '/stories' },
  { label: 'Contact Us', path: '/contact' },
]

export const programLinks = [
  { label: 'Leadership Development', path: '/programs/leadership-development' },
  { label: 'Cultural Initiatives', path: '/programs/cultural-initiatives' },
  { label: 'Women Empowerment', path: '/programs/women-empowerment' },
  { label: 'Good Governance', path: '/programs/good-governance-awareness' },
  { label: 'Nation Building', path: '/programs/nation-building-activities' },
  { label: 'Student Welfare', path: '/dimensions/student-welfare' },
]

export const getInvolvedLinks = [
  { label: 'Partner With Us', path: '/partner-with-us' },
  { label: 'Become a Volunteer', path: '/become-a-change-maker' },
  { label: 'Donate', path: '/contact' },
]

export const contactInfo = {
  location: 'Surat, Gujarat, India',
  address: '31/585, Indraprastha Apt., Guj. Housing Board, Surat, Gujarat 395008, India',
  phone: '+91 81604 64542',
  phoneHours: 'Mon-Sat: 9:00 AM - 6:00 PM',
  email: 'dishasurat2011@gmail.com',
  emailAlt: 'contact@dishafoundation.org',
}

export const footerQuickLinks = [
  { label: 'About Us', path: '/about-us' },
  { label: 'PLC Program', path: '/plc-4' },
  { label: 'Inspiring Stories', path: '/stories' },
  { label: 'Events', path: '/events' },
  { label: 'Contact Us', path: '/contact' },
]

export const footerProgramLinks = [
  { label: 'Public Leadership Camp', path: '/plc-4' },
  { label: 'Leadership Development', path: '/programs/leadership-development' },
  { label: 'Cultural Initiatives', path: '/programs/cultural-initiatives' },
  { label: 'Women Empowerment', path: '/programs/women-empowerment' },
  { label: 'Good Governance Awareness', path: '/programs/good-governance-awareness' },
  { label: 'Nation Building Activities', path: '/programs/nation-building-activities' },
]

export const footerGetInvolvedLinks = [
  { label: 'Become a Change Maker', path: '/become-a-change-maker' },
  { label: 'Partner With Us', path: '/partner-with-us' },
  { label: 'Join Events', path: '/events' },
]

export const socialLinks = [
  { label: 'YouTube', url: 'https://www.youtube.com/' },
  { label: 'X', url: 'https://x.com/' },
  { label: 'Instagram', url: 'https://www.instagram.com/' },
  { label: 'Facebook', url: 'https://www.facebook.com/' },
]
